export var slice = [].slice;



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-queue/src/array.js
// module id = ../../../../d3-queue/src/array.js
// module chunks = 4